import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from './tooltip-v2';

export const NotificationTooltip = ({ title, children, anchorClickCB, anchor, exitCB, show, arrowPlacement, placement = 'bottom' }) => {
  return (
    <div className="tooltip-container">
      <Tooltip
        placement={placement}
        tooltipClass="notification-popover"
        anchorClickCB={anchorClickCB}
        anchorType="custom"
        exitCB={exitCB}
        showX
        managedByParentVal={show}
        customAnchor={anchor}
        arrowPlacement={arrowPlacement}
      >
        <div className="notification-tooltip-body">
          <div className="text-white text-small heavy">
            <span className="new-container bg-green-200">
              NEW
            </span>
          </div>
          <div className="h6">{title}</div>
          <div className="text-gray-dark">
            {children}
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

NotificationTooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.object,
  anchorClickCB: PropTypes.func,
  anchor: PropTypes.object,
  exitCB: PropTypes.func,
  show: PropTypes.bool,
  arrowPlacement: PropTypes.object,
  placement: PropTypes.string
};
